import { combineReducers } from 'redux';
import PBI from './pbi.reducer';
import Player from './player.reducer';
import Campaign from './campaign.reducer';
import Content from './content.reducer';
import LiveMenu from './livemenu.reducer';
import Recording from './recording';
import OptionButtons from './optionButtons';
import Alert from './alert.reducer';
import Controls from './controls.reducer';
import EpgChannels from './epgChannels';
import PlayerLoader from './player-loader.reducer';
import Reminder from './reminder';
import Modals from './modals';
import Tracking from './tracking';
import EpgTransactions from './epgTransactions';
import Recomendations from './recomendations.reducer';
import FinPlayer from './fin-player.reducer';
import Series from './series.reducer';
import SkipIntro from './skip-intro.reducer';
import PictureInPicture from './pictureinpicture.reducer';
import Bookmark from './bookmark.reducer';
import Errors from './errors.reducer';
import UnixBegin from './unixBegin.reducer';
import Favorite from './favorite.reducer';
import RecordingSelected from './recordings.reducer';
import anonymousFinPlayer from './anonymousFinPlayer.reducer';
import timeshift from './timeshift.reducer';
import sensitiveContent from './sensitive.reducer';

export default combineReducers({
  Errors,
  PBI,
  Player,
  Campaign,
  Content,
  LiveMenu,
  Recording,
  OptionButtons,
  Alert,
  Controls,
  EpgChannels,
  Tracking,
  PlayerLoader,
  Reminder,
  Modals,
  EpgTransactions,
  Recomendations,
  FinPlayer,
  Series,
  SkipIntro,
  PictureInPicture,
  Bookmark,
  UnixBegin,
  Favorite,
  RecordingSelected,
  anonymousFinPlayer,
  timeshift,
  sensitiveContent,
});
